// SortContentDrawer.tsx
import {
  Drawer,
  DrawerContent,
  DrawerBody,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import { memo } from "react";
import { useTranslation } from "next-i18next";
import stationStore from "store/station";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";

const SortContentDrawer = memo(({ isOpenSort, setIsOpenSort }) => {
  const { t } = useTranslation();
  const { priceListSortBy } = stationStore;
  return (
    <Drawer
      isOpen={isOpenSort}
      onClose={() => setIsOpenSort(false)}
      size="4xl"
      placement="bottom"
    >
      <Box
        pos="absolute"
        top="0"
        left="0"
        bg="rgba(0, 0, 0, 0.5)"
        w="100%"
        h="100vh"
        zIndex={1500}
        onClick={() => setIsOpenSort(false)}
      ></Box>
      <Box zIndex={1600} pos="relative">
        <DrawerContent borderRadius="16px" pos="relative">
          <DrawerBody p="0px" maxH="calc(100vh - 48px)">
            <>
              <Flex
                px={{ base: "16px", lg: "32px" }}
                pt={{ base: "16px", lg: "32px" }}
                h={{ base: "64px", lg: "32px" }}
                justifyContent="flex-end"
              >
                <Flex
                  mt={{ base: "0px", lg: "-16px" }}
                  w="40px"
                  h="40px"
                  bg="#F3F4F9"
                  borderRadius="20px"
                  alignItems="center"
                  justifyContent="center"
                  cursor="pointer"
                  onClick={() => setIsOpenSort(false)}
                >
                  <CloseIcon w="14px" h="14px" />
                </Flex>
              </Flex>

              <Box mb="16px" px="16px">
                <Flex alignItems="center">
                  <Text textStyle="notoH24" color="#333333">
                    {t("sort")}
                  </Text>
                </Flex>
                {["sortFromLow", "sortFromHigh"].map((option, _index) => {
                  return (
                    <Flex
                      h="57px"
                      borderBottom="1px solid #E5E5E5"
                      key={option}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      onClick={(e) => {
                        stationStore.priceListSortBy = option;
                      }}
                    >
                      <Text
                        textStyle="notoP16"
                        color={
                          priceListSortBy === option ? "#0067D8" : "#333333"
                        }
                      >
                        {t(option)}
                      </Text>

                      <CheckIcon
                        w="16px"
                        h="16px"
                        display={priceListSortBy === option ? "block" : "none"}
                        color={
                          priceListSortBy === option ? "#0067D8" : "#333333"
                        }
                      />
                    </Flex>
                  );
                })}
              </Box>
            </>
          </DrawerBody>
        </DrawerContent>
      </Box>
    </Drawer>
  );
});

SortContentDrawer.displayName = "SortContentDrawer";

export default SortContentDrawer;
